export default __webpack_public_path__ + "static/media/convert-reward.44f5a35f.png";